export default function Phone({ color = "#9C98FF", size = 32, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      style={{ color }}
      {...props}
    >
      <path
        d="M28.985 21.885C28.7621 23.5788 27.9303 25.1335 26.6449 26.2588C25.3595 27.3841 23.7084 28.0031 22 28C12.075 28 4.00001 19.925 4.00001 9.99999C3.99695 8.2916 4.61587 6.64052 5.74118 5.35511C6.86649 4.0697 8.42122 3.23787 10.115 3.01499C10.5433 2.96269 10.9771 3.05032 11.3515 3.26479C11.7259 3.47926 12.0209 3.80907 12.1925 4.20499L14.8325 10.0987V10.1137C14.9639 10.4168 15.0181 10.7477 14.9904 11.0768C14.9627 11.406 14.8539 11.7231 14.6738 12C14.6513 12.0337 14.6275 12.065 14.6025 12.0962L12 15.1812C12.9363 17.0837 14.9263 19.0562 16.8538 19.995L19.8963 17.4062C19.9261 17.3811 19.9574 17.3578 19.99 17.3362C20.2666 17.1517 20.5849 17.0391 20.916 17.0086C21.2471 16.978 21.5806 17.0305 21.8863 17.1612L21.9025 17.1687L27.7913 19.8075C28.1879 19.9785 28.5185 20.2732 28.7337 20.6477C28.9489 21.0222 29.037 21.4562 28.985 21.885Z"
        fill="currentColor"
      />
    </svg>
  );
}
